import React from 'react';
import PropTypes from 'prop-types';
import Chevron from '../../assets/icons/chevron_right.svg';
import External from '../../assets/icons/external.svg';
import cn from 'classnames';
import { Link as InternalLink } from 'gatsby'
import isExternalLink from '../../util/isExternalLink'

const Link = ({ children, noStyle, className, type, href, label, target, ...props }) => {

  const typeClass = type === 'arrow' ? 'with-arrow' : 'standard';
  if (isExternalLink(href)) {
    const showExternalIcon = !/^(tel|mailto):/.test(href) && className !== "no-external"
    return (
      <a className={!noStyle ? cn('link', typeClass, className) : undefined} href={href} {...props} title={label}>
        {children}
        {type === 'arrow' ? <Chevron /> : (showExternalIcon && <External />)}
      </a>
    );
  } else {
    const state = {
      modal: /^(\/stappenplan\/|\/form\/)/.test(href),
    }
    return (
      <InternalLink to={href} state={state}  title={label} className={!noStyle ? cn('link', typeClass, className) : undefined} {...props}>
        {children}
        {type === 'arrow' ? <Chevron /> : ''}
      </InternalLink>
    )
  }
};

Link.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Link;
